<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-orders-refunds-payments-edit-payment')) {
      <ion-item button="true" (click)="presentOrderRefundPaymentEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
